import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const storageKey = 'route-filter-storage'

interface RouteFilterEntry {
  pathname: string
  search: string
}

interface RouteFilterState {
  routeFilters: Record<string, RouteFilterEntry | undefined>

  saveRouteSearch: (pathname: string, search: string) => void
  getRouteSearch: (pathname: string) => string
  clearRouteSearch: (pathname: string) => void
  reset: () => void
}

export const useRouteFilterStore = create<RouteFilterState>()(
  persist(
    (set, get) => ({
      routeFilters: {},

      saveRouteSearch: (pathname, search) => {
        const filters = get().routeFilters

        set({
          routeFilters: {
            ...filters,
            [pathname]: {
              pathname,
              search
            }
          }
        })
      },

      getRouteSearch: (pathname) => {
        const filters = get().routeFilters
        return filters[pathname]?.search || ''
      },

      clearRouteSearch: (pathname) => {
        const { [pathname]: _, ...rest } = get().routeFilters

        set({ routeFilters: rest })
      },

      reset: () => {
        set({ routeFilters: {} })
      }
    }),
    {
      name: storageKey,
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
